const THREADS = [
  { tag: '热议', title: '二版声明后，评论区站队复盘：觉得"实锤"的占几成', repl: 486, top: '楼主观点：删掉的"同事误会"才是关键，详见首楼图解。', agree: 1203 },
  { tag: '对线', title: '专楼：合伙人自述帖两派吵了三天，谁有原图谁有理', repl: 932, top: '热评：别急，聊天记录逐条核验帖已单独开楼。', agree: 781 },
  { tag: '补档', title: '被删的晒单原帖已存，欢迎补充更早版本', repl: 207, top: '已补 3 版截图，时间戳与正文对得上，见 37 楼。', agree: 355 },
  { tag: '求辟谣', title: '这张"直播数据图"是真是假？求会看的进来说', repl: 154, top: '从曲线平滑度看存疑，等数据还原图解更新中。', agree: 198 }
];

const RULES = ['理性讨论，不臆测身份', '原帖请先打码关键信息', '引用需注明出处与时间', '涉及澄清请提供证据'];

export default function Discussion() {
  return (
    <section id="discussion" className="bg-paper">
      <div className="mx-auto max-w-[1360px] px-4 py-10 md:px-6 md:py-14">
        <div className="mb-6 flex flex-wrap items-end justify-between gap-3 border-b-2 border-ink pb-3">
          <div>
            <div className="flex items-center gap-2">
              <i className="ri-message-3-line text-xl text-verm" />
              <h2 className="font-display text-xl font-black md:text-2xl">讨论版 · 正在围观</h2>
            </div>
            <p className="mt-1 text-sm text-ink/55">帖子下面是更长的讨论。每条都有引用与出处，欢迎带着证据进场。</p>
          </div>
          <a href="#discussion" className="flex items-center gap-1 text-sm text-ink/60 hover:text-verm">
            全部讨论 <i className="ri-arrow-right-line" />
          </a>
        </div>

        <div className="grid gap-5 lg:grid-cols-3">
          <div className="space-y-4 lg:col-span-2">
            {THREADS.map((t) => (
              <article key={t.title} className="group border border-line bg-paper2 p-4 transition-colors hover:border-verm/45 hover:bg-verm-wash md:p-5">
                <div className="flex flex-wrap items-center gap-2">
                  <span className="bg-verm px-1.5 py-0.5 text-[11px] font-semibold text-paper2">{t.tag}</span>
                  <span className="flex items-center gap-1 text-xs text-ink/45"><i className="ri-chat-3-line" /> {t.repl} 条回复</span>
                </div>
                <h3 className="mt-2 text-base font-bold leading-snug group-hover:text-verm md:text-lg">
                  <a href="#discussion" className="hover:text-verm">{t.title}</a>
                </h3>
                <div className="mt-2 rounded-md border-l-4 border-gold bg-gold-soft/40 px-3 py-2 text-sm text-ink/70">
                  <span className="text-[11px] font-bold text-gold">置顶 · </span>
                  {t.top}
                </div>
                <div className="mt-3 flex items-center gap-4 text-xs text-ink/50">
                  <span className="flex items-center gap-1 text-verm"><i className="ri-thumb-up-line" /> {t.agree} 顶</span>
                  <a href="#discussion" className="ml-auto flex items-center gap-1 font-semibold text-verm hover:opacity-75">
                    进楼围观 <i className="ri-arrow-right-s-line" />
                  </a>
                </div>
              </article>
            ))}
          </div>

          <aside className="space-y-5">
            <div className="border border-line bg-paper2 p-5">
              <h3 className="flex items-center gap-2 font-display text-base font-black">
                <i className="ri-scales-3-line text-verm" /> 讨论守则
              </h3>
              <ul className="mt-3 space-y-2.5">
                {RULES.map((r, i) => (
                  <li key={r} className="flex items-start gap-2 text-sm text-ink/70">
                    <span className="mt-0.5 flex h-4 w-4 shrink-0 items-center justify-center rounded-full bg-band text-[10px] font-bold text-verm">{i + 1}</span>
                    {r}
                  </li>
                ))}
              </ul>
              <a
                href="#discussion"
                className="mt-4 flex items-center justify-center gap-1 border border-verm py-2.5 text-sm font-semibold text-verm hover:bg-verm-soft"
              >
                <i className="ri-add-circle-line" /> 发起一条讨论
              </a>
            </div>

            <div className="bg-espresso p-5 text-paper2">
              <div className="flex items-center gap-2">
                <i className="ri-bubble-chart-line text-lg text-gold" />
                <h3 className="font-display text-base font-black">理性吃瓜提醒</h3>
              </div>
              <p className="mt-2 text-sm leading-relaxed text-paper2/70">
                所有内容均来自公开网络讨论的整理与复述，不构成对任何人的定性。涉及当事人欢迎带证据投稿澄清，我们会同样按时间线归档。
              </p>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}